'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function OfficesController($document) {
	'ngInject';

	// const vm = this;
	init();

	/** */
	function init() {
		$document.scrollTo(angular.element(document.getElementById('officesContainer')), 200, 100);
	}
}

exports['default'] = OfficesController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/public/main/offices/offices.controller.js
 **/